var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-article-modal"},[_c('div',{staticClass:"dashboard-article-modal__card"},[_c('MVPArticlesForm',{attrs:{"article":_vm.article,"articleKey":_vm.articleKey,"groups":_vm.groups,"stay-on-dashboard":_vm.stayOnDashboard,"can-renotify":_vm.canRenotify},on:{"refresh":_vm.forwardRefresh,"close":_vm.closeModal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }